import usePrivateAxios from "@/common/api/usePrivateAxios"
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { useMutation } from "@tanstack/react-query"

interface UseDeleteEstablishmentCompanyMaintenanceSpecificationProps {
  establishmentCompanyId: string;
  maintenanceSpecification: EstablishmentCompanyData['maintenance_specifications'][number];
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const useDeleteEstablishmentCompanyMaintenanceSpecification = ({
  establishmentCompanyId,
  maintenanceSpecification,
  onSuccess,
  onError,
}: UseDeleteEstablishmentCompanyMaintenanceSpecificationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentCompanyMaintenanceSpecification'],
    mutationFn: () => {
      const payload = {
        maintenance_specifications_attributes: [
          {
            id: maintenanceSpecification.id,
            _destroy: true,
          },
        ],
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompanyId}/update_maintenance_models`, {
        company: payload,
      });
    },
    onSuccess,
    onError,
  })
}
